import { render, staticRenderFns } from "./DiscardOrganisationCreationModal.vue?vue&type=template&id=017df839&"
import script from "./DiscardOrganisationCreationModal.vue?vue&type=script&lang=ts&"
export * from "./DiscardOrganisationCreationModal.vue?vue&type=script&lang=ts&"
import style0 from "./DiscardOrganisationCreationModal.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports